import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import './SubscriptionSuccess.css';

function SubscriptionSuccess() {
  const navigate = useNavigate();
  // session_id available via useSearchParams if needed for verification

  useEffect(() => {
    // Auto-redirect to home after 5 seconds
    const timer = setTimeout(() => {
      navigate('/home');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="subscription-success">
      <div className="success-container">
        <div className="success-icon">🎉</div>
        <h1>Welcome to Hangrily Premium!</h1>
        <p className="success-message">
          Your subscription is now active. Enjoy unlimited swipes and all premium features!
        </p>
        
        <div className="success-features">
          <h3>You now have access to:</h3>
          <ul>
            <li>✓ Unlimited restaurant swipes</li>
            <li>✓ Solo, Couple, and Group modes</li>
            <li>✓ Partner linking</li>
            <li>✓ Decision history tracking</li>
            <li>✓ Custom preferences</li>
            <li>✓ Priority support</li>
          </ul>
        </div>

        <button 
          className="btn btn-primary btn-lg"
          onClick={() => navigate('/home')}
        >
          Start Swiping!
        </button>

        <p className="redirect-text">
          Redirecting to home in 5 seconds...
        </p>
      </div>

      <Footer />
    </div>
  );
}

export default SubscriptionSuccess;
